import { cloneObject } from "../scripts/cloneObject";

export const duplicateWithIndex = (el, count, allObjects) => {
    // Оригинал получает __1 (только если еще нет числа на конце)
    el.name = el.name.replace(/(__\d+)?$/, "__1");

    // Клоны получают __2, __3 и т.д.
    for (let i = 2; i <= count; i++) {
        const clone = cloneObject(el);
        clone.name = el.name.replace(/__\d+$/, `__${i}`);
        allObjects.push(clone);
    }
};
